import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from 'firebase/auth';


const firebaseConfig = {
  apiKey: "AIzaSyBF-JKLPt0VXw8QOqPhlZlILc1AoqZbAlA",
  authDomain: "ippotamilvalarchi.firebaseapp.com",
  projectId: "ippotamilvalarchi",
  storageBucket: "ippotamilvalarchi.firebasestorage.app",
  messagingSenderId: "375289035579",
  appId: "1:375289035579:web:48bd4e1113a6a0a229151e",
  measurementId: "G-W447YVWFV5"
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// Initialize Firebase Auth and Google Provider
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { auth, googleProvider };
